import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";
import type { ProjectOutcome, ProjectState } from "@/engine/types";
import { EffectChips } from "./DecisionLog";

export default function RetrospectivePanel({
  state,
  outcome,
  onRestart,
}: {
  state: ProjectState;
  outcome: ProjectOutcome;
  onRestart: () => void;
}) {
  return (
    <Card className="p-6 bg-card border-border">
      <Badge className="bg-accent text-accent-foreground mb-3 gap-1">
        <span className="leading-none">🏁</span>
        {outcome.label}
      </Badge>
      <h2 className="text-lg font-display font-bold text-foreground mb-2">
        Retrospective — Day {state.day}
      </h2>
      <p className="text-sm font-body text-muted-foreground mb-6 leading-relaxed">
        {outcome.summary}
      </p>

      <p className="text-xs font-semibold font-body text-foreground mb-3">
        Decision history — what drove the outcome
      </p>
      <div className="space-y-4 mb-6">
        {state.history.map((h, i) => (
          <div key={i} className="border-l-2 border-border pl-3">
            <p className="text-[11px] font-mono text-muted-foreground">
              Day {h.day} · {h.eventTitle}
            </p>
            <p className="text-sm font-body font-semibold text-card-foreground">{h.choiceText}</p>
            <p className="text-xs font-body text-muted-foreground mt-0.5">{h.resultText}</p>
            <EffectChips effects={h.effects} />
          </div>
        ))}
      </div>

      <Button onClick={onRestart}>
        <RotateCcw className="h-3.5 w-3.5 mr-1.5" />
        Play again
      </Button>
    </Card>
  );
}
